<template>
  <div style="height: 79vh; overflow-y: scroll;" class="mb-5">
    <div class="container-fluid">
      <img
        src="../../assets/profile-bg.jpg"
        width="100%"
        height="170px"
        style="object-fit: cover;"
      />
      <!-- <img :src="user.photoURL" width="112px" height="112px" style="border: 2px solid #ffe; border-radius: 50%; margin-top: -50px; margin-left: 10px" > -->

      <div v-if="!is_edit">
        <img
          :src="user.photoURL"
          width="150px"
          height="150px"
          style="border: 2px solid #ffe; border-radius: 50%; margin-top: -50px; margin-left: 10px"
        />
      </div>
      <div v-else>
        <div>
          <img
            id="profilePhoto"
            :src="user.photoURL"
            width="150px"
            height="150px"
            style="border: 2px solid #ffe; border-radius: 50%; margin-top: -50px; margin-left: 10px"
          />
          <vue-dropzone
            ref="myVueDropzone"
            :options="dropzoneOptions"
            :awss3="awss3"
            v-on:vdropzone-s3-upload-error="s3UploadError"
            v-on:vdropzone-s3-upload-success="s3UploadSuccess"
            v-on:vdropzone-thumbnail="thumbnail"
            id="customdropzone"
            v-on:vdropzone-file-added="vfileAdded"
          >
          </vue-dropzone>
        </div>
      </div>

      <!-- 
			<div v-if="user.photoURL === ''">
              <label>Choose Logo</label>
              <vue-dropzone
                ref="myVueDropzone"
                :options="dropzoneOptions"
                :awss3="awss3"
                v-on:vdropzone-s3-upload-error="s3UploadError"
                v-on:vdropzone-s3-upload-success="s3UploadSuccess"
                id="dropzone"
                v-on:vdropzone-file-added="vfileAdded"
                style="background: #1B1B1B"
              >
              </vue-dropzone>
            </div>
            <div v-else class="mb-2">
                <button
                  class="btn btn-outline-danger btn-sm"
				  v-if="is_edit"
                  @click="user.photoURL = ''"
                >
                  Change Profile Photo
                </button>
            </div> -->

      <!--			<button class="btn btn-info btn-sm" style="position: absolute; top: 100px; right: 30px">-->
      <!--				Change Cover-->
      <!--				<i class="fas fa-image"></i>-->
      <!--			</button>-->
    </div>
    <section class="container" v-if="is_edit">
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary float-right" @click="userUpdate">
            Save Changes
            <i class="fas fa-pencil-alt"></i>
          </button>
        </div>
        <div class="col-12 col-sm-6">
          <h5>Basic Info</h5>
          <div class="form-group	">
            <label for="firstName">Name</label>
            <input
              type="text"
              class="form-control"
              id="firstName"
              placeholder="Enter Name"
              v-model="user.name"
            />
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="designation">Designation</label>
                <input
                  type="text"
                  class="form-control"
                  id="designation"
                  placeholder="Enter designation"
                  v-model="user.designation"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="company">Company</label>
                <input
                  type="text"
                  class="form-control"
                  id="company"
                  placeholder="Enter company name"
                  v-model="user.company"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="city">City</label>
                <input
                  type="text"
                  class="form-control"
                  id="city"
                  placeholder="Enter city name"
                  v-model="user.city"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="city">Country</label>
                <input
                  type="text"
                  class="form-control"
                  id="country"
                  placeholder="Enter country name"
                  v-model="user.country"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Bio</label>
            <textarea
              class="form-control"
              style="background:transparent"
              v-model="user.bio"
              placeholder="Write about yourself."
            ></textarea>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <h5>More Info</h5>
          <div class="form-group">
            <label for="linkedinProfile">LinkedIn</label>
            <input
              type="email"
              class="form-control"
              id="linkedinProfile"
              v-model="user.linkedin_url"
              placeholder="Enter Linked In"
            />
          </div>
          <div class="form-group">
            <label for="facebook">Facebook</label>
            <input
              type="email"
              class="form-control"
              id="facebook"
              v-model="user.fb_url"
              placeholder="Enter Facebook"
            />
          </div>
          <div class="form-group">
            <label for="twitterProfile">Twitter</label>
            <input
              type="email"
              class="form-control"
              id="twitterProfile"
              v-model="user.twitter_url"
              placeholder="Enter Twitter"
            />
          </div>
          <!--					<div class="form-group">-->
          <!--						<label>Quick Intro</label>-->
          <!--						<div style="height: 96px; border: 1px solid rgb(108, 117, 124); border-radius: 12px">-->
          <!--							<button class="btn btn-primary" style="position: absolute; top: 67%; left: 50%; transform: translate(-50%, -50%)">-->
          <!--								Record-->
          <!--								<i class="fas fa-video"></i>-->
          <!--							</button>-->
          <!--						</div>-->
          <!--					</div>-->
        </div>
      </div>
    </section>
    <section class="container" v-else>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary float-right" @click="is_edit = true">
            Edit Profile
            <i class="fas fa-pencil-alt"></i>
          </button>
        </div>
        <div class="col-12 col-sm-6">
          <h5>Basic Info</h5>
          <div class="form-group	">
            <label for="firstName">Name</label>
            <p>{{ user.name }}</p>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="designation">Designation</label>
                <p>{{ user.designation }}</p>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="company">Company</label>
                <p>{{ user.company }}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="city">City</label>
                <p>{{ user.city }}</p>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="city">Country</label>
                <p>{{ user.country }}</p>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Bio</label>
            <p>{{ user.bio }}</p>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <h5>More Info</h5>
          <div
            class="form-group"
            v-if="
              user.linkedin_url === '' &&
                user.fb_url === '' &&
                user.twitter_url === ''
            "
          >
            <p>Update Your social information</p>
          </div>
          <div class="form-group" v-else>
            <a
              class="mr-2"
              v-if="user.linkedin_url"
              :href="user.linkedin_url"
              target="_blank"
              ><i class="fab fa-linkedin" style="font-size: 25px;"></i
            ></a>

            <a
              class="mr-2"
              v-if="user.fb_url"
              :href="user.fb_url"
              target="_blank"
              ><i class="fab fa-facebook-square" style="font-size: 25px;"></i
            ></a>

            <a
              class="mr-2"
              v-if="user.twitter_url"
              :href="user.twitter_url"
              target="_blank"
              ><i class="fab fa-twitter-square" style="font-size: 25px;"></i
            ></a>
          </div>
          <!--					<div class="form-group">-->
          <!--						<label>Quick Intro</label>-->
          <!--						<div style="height: 96px; border: 1px solid rgb(108, 117, 124); border-radius: 12px">-->
          <!--							<button class="btn btn-primary" style="position: absolute; top: 67%; left: 50%; transform: translate(-50%, -50%)">-->
          <!--								Record-->
          <!--								<i class="fas fa-video"></i>-->
          <!--							</button>-->
          <!--						</div>-->
          <!--					</div>-->
        </div>
      </div>
    </section>
    <hr />
    <section id="accountSetting">
      <div class="container">
        <h5>Account Settings</h5>
        <div class="row">
          <div class="col-12 col-md-6">
            <div style="float: left">
              <label>Your Email</label>
              <p>{{ user.email }}</p>
            </div>
            <button
              class="btn btn-primary"
              style="float:right; padding: 5px 35px"
              disabled
            >
              Change
            </button>
          </div>
          <div class="col-12 col-md-6">
            <div style="float: left">
              <label>Your Activity</label>
              <p>
                Last active on {{ user.last_active | moment("MMMM Do YYYY") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="mt-4">
      <div class="text-center">
        <h6>
          <span class="text-danger">Danger zone</span>
        </h6>
        <button
          class="btn btn-danger"
          style="margin: 5% 0;"
          data-toggle="modal"
          data-target="#deleteAccount"
        >
          Deactivated Account
        </button>
      </div>
    </section>
    <div class="position-center" id="loader" style="width: 5%; display: none;">
      <img src="../../assets/loader.gif" alt="" style="width: 100%" />
    </div>
    <div
      class="modal"
      id="deleteAccount"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteAccount"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <i class="fas fa-question fa-4x"></i>
            <div class="mt-2 mb-2">
              <p class="modal-title"><b>Are you sure?</b></p>
              <p>You can login back to meetbeans account.</p>
            </div>
            <button
              type="submit"
              @click="deleteAccount"
              id="yes-deactive"
              class="btn btn-primary"
            >
              Yes, deactive
            </button>
            <button
              class="btn btn-secondary ml-2"
              id="no-deactive"
              data-dismiss="modal"
              aria-label="Close"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "dashboard",
  data() {
    return {
      file_name: "",
      oldPhotoUrl: "",
      baseUrl: this.$store.state.baseUrl,
      is_edit: false,
      user: { is_admin: false, company: "NA", designation: "NA" },
      dropzoneOptions: {
        previewTemplate: this.template(),
        url: "https://httpbin.org/post",
        maxFilesize: 10,
        maxFiles: 1,
        acceptedFiles: "image/*",
        params: {
          success_action_status: 201,
        },
        addRemoveLinks: true,
        headers: { "Access-Control-Allow-Origin": "*" },
        dictDefaultMessage: 'UPLOAD <i class="fas fa-upload"></i>',
      },
      awss3: {
        signingURL: this.baseUrl + "/signature", //Where you will get signed url
        headers: {},
        params: {},
        sendFileToServer: true, //If you want to upload file to your server along with s3
        withCredentials: false,
      },
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  created() {
    if (localStorage.getItem("user_info")) {
	  this.user = JSON.parse(localStorage.getItem("user_info"));
    }
    this.getUser();
  },
  methods: {
    template: function() {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-image">
                    <div data-dz-thumbnail-bg></div>
                </div>
                <div class="dz-progress" style="margin-left: 3px;"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>
            </div>
        `;
    },
    thumbnail: function(file, dataUrl) {
      var j, len, ref, thumbnailElement;
      if (file.previewElement) {
        file.previewElement.classList.remove("dz-file-preview");
        ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j];
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
        }
        return setTimeout(
          (function() {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this),
          1
        );
      }
    },
    vfileAdded(file) {
      // console.log(file);
      this.file_name = file.name;
      this.awss3.signingURL = this.baseUrl + "/signature/" + this.file_name;
      this.dropzoneOptions.url = this.baseUrl + "/signature/" + this.file_name;
	},
	vfileRemoved(file){
		console.log(file, 'removed', this.oldPhotoUrl);
		  
	},
    s3UploadError(errorMessage) {
      console.log(errorMessage);
    },
    s3UploadSuccess(s3ObjectLocation) {
      // console.log('s3 object: ', s3ObjectLocation)
      this.user.photoURL = s3ObjectLocation;
    },
    getUser: function() {
      let data = {
        uid: this.user.uid,
        email: this.user.email,
      };
      this.$store.dispatch("getUserInfo", data).then((resp) => {
        if (resp.data.status === "success") {
          this.user = resp.data.data;
		  //   console.log(this.user)  
        }
      });
    },
    userUpdate: function() {
      this.$store.dispatch("updateUser", this.user).then((resp) => {
        if (resp.data.status === "success") {
          this.is_edit = false;
          // console.log('uu: ', this.user);
          this.$root.$emit("updateUserInfo", this.user);
          localStorage.setItem("user_info", JSON.stringify(this.user));
          this.$toast.open({
            message: "Profile updated",
            type: "success",
            position: "top",
            queue: true,
		  });
        }
      });
    },
    deleteAccount: function() {
      this.$store.dispatch("deleteAccount").then((resp) => {
        if (resp.data.status === "success") {
          document.getElementById("no-deactive").click();
          Swal.fire(
            "You account is successfully deactivated",
            "We'll miss you, see you back soon",
            "success"
          );
          this.$root.$emit("logout");
        }
      });
    },
  },
};
</script>
<style scoped>
#customdropzone {
  position: relative;
  color: #fff;
  background: rgba(239, 15, 15, 0.3);
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin-top: -150px;
  margin-left: 10px;
}
#customdropzone .dz-preview {
  width: 160px;
  display: inline-block;
}
#customdropzone .dz-preview .dz-image {
  width: 80px;
  height: 80px;
  margin-left: 40px;
  margin-bottom: 10px;
}
#customdropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  border-radius: 50%;
  background-size: contain;
}
#customdropzone .dz-preview .dz-image > img {
  width: 100%;
}
#customdropzone .dz-remove {
  display: none;
}
h6 {
  margin: 10px 0px;
  font-size: 10px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #e43f52;
  line-height: 0;
  background: #000;
}

h6 span {
  padding: 0 20px;
  background: #000;
  font-size: 14px;
}
</style>
